import { render, staticRenderFns } from "./GruppoToggle.vue?vue&type=template&id=617719ad&scoped=true&"
import script from "./GruppoToggle.vue?vue&type=script&lang=js&"
export * from "./GruppoToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617719ad",
  null
  
)

export default component.exports